window.x2 = {
  url: window.location.protocol + '//' + (window.location.hostname === 'localhost' ? window.location.hostname+':7001' : window.location.hostname),
  api: window.location.hostname === 'localhost' ? '/data/v1/' : '/project-api/videogia/data/v1/',
  auth: 'api',
  authsrvUrl: 'https://esia.rcoi05.ru/auth/esia/redirect',
  authsrvLinkText: 'Вход через ЕСИА',
  authsrv: {
    host: '10.50.0.80',
    port: '8989',
    appkey: 'hjfnvk123kjfkn'
  },
  authType: 'cookie',
  enableSso: true,
  additionalHeaders: {},
  au: 'FACE9B8833124681ADE14BCF0776E37B',
  tables: {
    rooms: 'B5E435C33D6E480999B9E97A2E35C82F',
    egerooms: 'CD65D244F08C44EE87DD6AF2618F167B',
    schools: 'CA4482DFF5F1405EA64A89CE9B5F5B6E',
    pak: '0A550A4E7DCA4F899BC645E6A1A8B8C5',
    pakege: '89828616E98D4644B720035824A3DA17',
    users: '3787D8D750134091BD6CE9306193A0F2',
    surveillance: '024BB3B5E72742F1AFFBDE9E0E5B6722',
    pakview: '800792742DCC401B9352118EDCC6F277',
    violations: '26EC733458C9451296965735D0ACDD73',
    reasons: '6972D435F4AE4FD2A4CD5E29B858D57C',
    otherreasons: '38B6DE21A19B4ADEA197F75E357AA083',
    news: '940ac548-b017-48a7-82f2-ca9361bf0eca',
    history: 'dd64f1f6-0ff7-4f7b-9da3-f63ddf1ff57f'
  },
  streams: {
    count: 4,
    perPage: 4
  },
  violation: {
    sent : 'Новое нарушение',
    review : 'На проверке',
    processed : 'Отработано',
    returned : 'Возвращено'
  },
  multiSort: false
}
